import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'

import HelpPane from 'components/Common/HelpPane'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function BedbankSoldOutModal() {
  const intl = useIntl()
  const { resolve } = useModalElementContext<void>()
  const modalClose = () => resolve()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'VcT3Y64MTL',
        defaultMessage: 'This room option is no longer available',
        description: 'Modal title when selected room option is sold out on the offer detail page',
      })}
      primaryActionText={intl.formatMessage({
        id: '7vW1jE9j42',
        defaultMessage: 'Select a different room option',
        description: 'Button label to select an alternative room option on the form',
      })}
      onPrimaryActionClick={modalClose}
    >
      <BodyText variant="large" weight="normal">
        {intl.formatMessage({
          id: '5Aaq4KMYOK',
          defaultMessage: 'Unfortunately your selected room option sold out before we could secure them. Luckily there are alternative options for you to choose from, but make sure to act fast!',
          description: 'Message informing user their selected room sold out and suggesting alternatives',
        })}
      </BodyText>
      <HelpPane />
    </Modal>
  )
}

export default BedbankSoldOutModal
